import React, { useState, useEffect } from 'react';
import '../styles/Notification.css';

// Singleton pour gérer les notifications à travers l'application
export const NotificationManager = {
  showNotification: null,
  
  setShowFunction(showFn) {
    this.showNotification = showFn;
  },
  
  show(title, message, type = 'success') {
    if (this.showNotification) {
      this.showNotification(title, message, type);
    }
  }
};

const Notification = () => {
  const [visible, setVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('success'); // success, error, warning
  
  useEffect(() => {
    // Enregistrer la fonction showNotification dans le singleton
    NotificationManager.setShowFunction((title, message, type) => {
      setTitle(title);
      setMessage(message);
      setType(type);
      setVisible(true);
      
      // Masquer après 3 secondes
      setTimeout(() => {
        setVisible(false);
      }, 3000);
    });
  }, []);
  
  const handleClose = () => {
    setVisible(false);
  };
  
  if (!visible) return null;
  
  return (
    <div className={"notification " + type + (visible ? ' show' : '')}>
      <div className="notification-content">
        <div className="notification-title">{title}</div>
        <div className="notification-message">{message}</div>
      </div>
      <div className="notification-close" onClick={handleClose}>×</div>
    </div>
  );
};

export default Notification;
